/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_HlsInputs */



/**
* | output |
* | --- |
* | "HLS Manifest" |
*
* @param {Media_Import_Source_HlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_hls = /** @type {((inputs?: Media_Import_Source_HlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_HlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manifeste HLS")
	if (locale === "de") return /** @type {LocalizedString} */ ("HLS-Manifest")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manifesto HLS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Манифест HLS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manifiesto HLS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("HLS清单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("HLSマニフェスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एचएलएस मैनिफेस्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manifesto HLS")
	return /** @type {LocalizedString} */ ("HLS Manifest")
});